const toggleBtn = document.querySelector('.chat-toggle')
const container = document.querySelector('#embedded-widget-container')

if (toggleBtn && container) {
	toggleBtn.addEventListener('click', () => {
		container.classList.toggle('open')
	})
}
